import { Component, OnInit } from '@angular/core';
import { BeStudyCosting } from 'shared/models/bestudycosting';
import { BeStudyCostingService } from './be-study-costing.service';

@Component({
  selector: 'app-be-study-costing',
  templateUrl: './be-study-costing.component.html',
  styleUrls: ['./be-study-costing.component.scss']
})
export class BeStudyCostingComponent implements OnInit {
  StudyCosting: any[];
  pilotStudyCosting: any[];
  pivotalStudyCosting: any[];
  tablekey: any[];
  cols: any[];
  columns: any[];

  constructor(private beStudyCostingService: BeStudyCostingService) { }

  ngOnInit(): void {
    this.beStudyCostingService.getRegCostingDetails().subscribe((res: any) => {
      this.StudyCosting = res.BE_Study_Cost;
      this.tablekey = Object.values(res.BE_Study_Cost[0]);
      this.pilotStudyCosting = res.BE_Study_Cost[0].table_data;
      this.pivotalStudyCosting =  res.BE_Study_Cost[1].table_data;
    });
    this.cols = [
      { field: 'study_design', header: 'Study design' },
      { field: 'total_treatment', header: 'Total treatment period' },
    ]
    this.columns = [
      { field: 'slno', header: '' },
      { field: 'study', header: 'Study' },
      { field: 'total_treatment_period', header: 'Total Treatment Period' },
      { field: 'Approx', header: 'Approx Be Study Cost ($ per subject per period)' },
      { field: 'Total_cost', header: 'Total cost ($)' },
    ];
  }

}
